var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 36C11.161 36 4.00098 28.84 4.00098 20C4.00098 11.16 11.161 4 20.001 4C28.841 4 36.001 11.16 36.001 20C36.001 28.84 28.841 36 20.001 36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2605 13.4701H24.7405V10.7101C23.8505 10.5801 22.8805 10.5001 21.9805 10.5101C21.3605 10.5201 20.7505 10.6701 20.2005 10.9601C19.1105 11.5301 18.3305 12.6001 18.1305 13.8101C18.0905 14.0201 18.0805 14.2401 18.0805 14.4601V17.2401H15.2705V20.4501H18.0905V29.5101H21.5505V20.4501H24.2705L24.7105 17.2401H21.5505V15.2001C21.5305 14.2401 22.3005 13.4701 23.2605 13.4701Z",
    fill: "#72BF44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.49dc6d6eebf7a728e37f80531d5c1875.svg";
export { ForwardRef as ReactComponent };